import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Breadcrumb as AntBreadcrumb } from 'antd';
import styled from 'styled-components';

const Breadcrumb = styled(AntBreadcrumb)`
  span {
    color: var(--text-primary);
    font-size: 14px;

    &.ai {
      color: var(--dark-blue);
      cursor: pointer;
    }
  }
`;

type Props = {
  company: string;
};

const RecommendationBreadcrumb = ({ company }: Props) => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <Breadcrumb
      items={[
        { title: company },
        {
          className: 'ai',
          title: 'AI Competitive Intelligence',
          onClick: goBack,
        },
      ]}
      separator="·"
    />
  );
};

export default RecommendationBreadcrumb;
